import { type UseControllerProps, useCustomController } from '@faceup/form'
import { FormItem } from '@faceup/ui'
import { FORM_ITEMS, FormItemType, type Language } from '@faceup/utils'
import { FileFormElement } from '../../components/FileForm/FileFormElement'

type AFFileFormInputProps = UseControllerProps & {
  anonymityInfo?: { enabled: boolean; language?: Language }
}

export const AFFileFormInput = ({ anonymityInfo, ...props }: AFFileFormInputProps) => {
  const { formItemProps, inputProps } = useCustomController(props)

  return (
    <FormItem {...formItemProps} notClickableLabel>
      <input className='invisible absolute h-[0] w-[0]' readOnly tabIndex={-1} />
      <FileFormElement
        name={props.name}
        multiple={true}
        maxCount={FORM_ITEMS[FormItemType.File].maxFormCount}
        className='w-full'
        anonymityInfo={anonymityInfo}
        onChange={({ fileList }) => {
          const files = fileList.map(file => file.originFileObj as File).filter(Boolean)
          inputProps.onChange(files)
        }}
      />
    </FormItem>
  )
}
